import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types/api';
import { IBookBalanceApiListResponse } from '@/types/bookBalance';

export const bookBalance = (
    params: IApiListParams & { currencyId?: number | null },
    config?: AxiosRequestConfig
): Promise<AxiosResponse<IBookBalanceApiListResponse>> => {
    return axios.get('/api/bookbalance/list', { ...config, params });
};

export const bookBalanceExport = (params: IApiListParams & { currencyId?: number | null }): Promise<AxiosResponse<Blob>> => {
    return axios.get('/api/bookbalance/export', { params, responseType: 'blob' });
};
